import React, { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import UserAvatar from "../../images/user.jpg";
import "./DummyDashboard.scss";
import BannerImg from "../../images/background_stretched_300dpi.png";
import { officeName, permissionsVariables } from "../../services/Functions";
import { cfpBaseUrl } from "../../network/urls";
const quickActions = [
  {
    title: "View Applications",
    description: "View and process pending applications",
    icon: DescriptionOutlinedIcon,
  },
  {
    title: "Create New Application",
    description: "Initiate a new application",
    icon: AddBoxOutlinedIcon,
  },
  {
    title: "Search Application",
    description: "Search and track existing applications",
    icon: SearchOutlinedIcon,
  },
  {
    title: "Download Reports",
    description: "Download system reports",
    icon: DownloadOutlinedIcon,
  },
  // {
  //   title: "Manage Profile",
  //   description: "View and update your profile information",
  //   icon: PersonOutlineOutlinedIcon,
  // },
  {
    title: "System Notices",
    description: "View important announcements",
    icon: NotificationsNoneOutlinedIcon,
  },
];

// notices removed — dashboard now shows only API-provided eOps updates

const MetaBlock = ({ icon: Icon, label, value }) => (
  <Box className="dummy-dashboard__meta-item">
    <Box className="dummy-dashboard__meta-icon">
      <Icon fontSize="small" />
    </Box>
    <Box>
      <Typography className="dummy-dashboard__meta-label">{label}</Typography>
      <Typography className="dummy-dashboard__meta-value">{value}</Typography>
    </Box>
  </Box>
);

const DummyDashboard = () => {
  const {
    name,
    roleName,
    cnic,
    cfcLevelName,
    email,
    phoneNo,
    lastLoginTime,
    profilePicture,
    code,
    token,
    roleTypeId,
  } = useSelector((state) => state.auth);
    const [subDivisions, setSubDivisions] = useState(
      JSON.parse(window.localStorage.getItem("subDivisions")) || [],
    );
     const [officeNameForDashboard, setOfficeNameForDashboard] = useState(
        officeName(code ? code : '', subDivisions),
      );
useEffect(()=>{
setOfficeNameForDashboard(officeName(code, subDivisions));
},[code, subDivisions])

function formatDateTime(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();
  const year = date.getFullYear();
  const time = date.toLocaleTimeString('en-US'); // keeps AM/PM format

  const month = date.toLocaleString('en-US', { month: 'long' });

  return `${day} ${month} ${year} ${time}`;
}
  const dashboardMeta = [
    {
      label: "Role",
      value: roleName,
      icon: PersonOutlineOutlinedIcon,
    },
    {
      label: "Office",
      value: code === '10' ? "Power Information Technology Company (PITC)":officeNameForDashboard,
      icon: BusinessOutlinedIcon,
    },
    {
      label: "Last Login",
      value: lastLoginTime? formatDateTime(lastLoginTime) : '-',
      icon: AccessTimeOutlinedIcon,
    },
  ];

  const maskCnic = (cnicValue) => {
    if (!cnicValue && cnicValue !== 0) return "-";
    const str = String(cnicValue || "");
    const digits = str.replace(/\D/g, "");
    if (digits.length < 8) return str;
    const first = digits.slice(0, 4);
    const last = digits.slice(-4);
    return `${first}*****${last}`;
  };

  const [eopsNotices, setEopsNotices] = useState([]);
  const [eopsTotalCount, setEopsTotalCount] = useState(0);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const navigate = useNavigate();

  // fetch eOps updates to show on dashboard
  useEffect(() => {
    let mounted = true;
    const fetchEops = async () => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        if (token) myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
        const body = JSON.stringify({
          pageNumber: "1",
          pageSize: "10",
          officeCode: code ? String(code).slice(0, 2) : "10",
        });
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body,
          redirect: "follow",
        };

        const res = await fetch(cfpBaseUrl + "eOpsUpdates/get", requestOptions);
        const text = await res.text();
        let json = null;
        try {
          json = JSON.parse(text);
        } catch (e) {
          json = res.ok ? await res.json() : null;
        }

        if (
          mounted &&
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const mapped = json.data.map((it) => ({
            title: it.title || "",
            description: it.description || "",
            tone: it.isActive ? "info" : "warning",
            id: it.id,
            updateTypeId: it.updateTypeId ?? it.updateType?.updateTypeId,
            updateTypeName: it.updateTypeName ?? it.updateType?.updateTypeName,
          }));
          setEopsNotices(mapped);
          setEopsTotalCount(
            Number(
              json.totalRecords ??
                json.totalCount ??
                json.total ??
                mapped.length,
            ) || mapped.length,
          );
        }
      } catch (e) {
        console.error("Failed to fetch eOps updates for dashboard", e);
      } finally {
        setViewBackdrop(false);
      }
    };
    fetchEops();
    return () => {
      mounted = false;
    };
  }, [token, code]);

  // pick an icon component based on the update type id/name
  const getUpdateIcon = (typeId, typeName) => {
    switch (Number(typeId)) {
      case 1:
        return InfoOutlinedIcon;
      case 2:
        return NewReleasesOutlinedIcon;
      case 3:
        return SecurityOutlinedIcon;
      case 4:
        return InfoOutlinedIcon;
      case 5:
        return BugReportOutlinedIcon;
      case 6:
        return BuildOutlinedIcon;
      case 7:
        return LinkOutlinedIcon;
      case 8:
        return InsertChartOutlinedIcon;
      case 9:
        return NotificationsActiveOutlinedIcon;
      case 10:
        return CalendarTodayOutlinedIcon;
      case 11:
        return ArchiveOutlinedIcon;
      case 12:
        return ReportProblemOutlinedIcon;
      default:
        // fallback: try matching by name
        if (typeof typeName === "string") {
          const name = typeName.toLowerCase();
          if (name.includes("security")) return SecurityOutlinedIcon;
          if (name.includes("release") || name.includes("release"))
            return NewReleasesOutlinedIcon;
          if (name.includes("api") || name.includes("integration"))
            return LinkOutlinedIcon;
          if (name.includes("data") || name.includes("report"))
            return InsertChartOutlinedIcon;
        }
        return AssignmentOutlinedIcon;
    }
  };

  // pick a subtle background color for the update type
  const getUpdateBgColor = (typeId, typeName) => {
    switch (Number(typeId)) {
      case 1: // System Announcement
        return "#e8f4ff";
      case 2: // Release Announcement
        return "#e6fff4";
      case 3: // Security Announcement
        return "#fff4e6";
      case 4: // General Announcement
        return "#f5f5f7";
      case 5: // Testing / QA
        return "#f3e8ff";
      case 6: // Developer
        return "#e8fff0";
      case 7: // API / Integration
        return "#eef2ff";
      case 8: // Data / Reporting
        return "#fff8e6";
      case 9: // User Notification
        return "#e6f7ff";
      case 10: // Scheduled
        return "#bdd8f7";
      case 11: // Feature Deprecation
        return "#fff1f0";
      case 12: // Incident / Emergency
        return "#e57272";
      default:
        if (typeof typeName === "string") {
          const name = typeName.toLowerCase();
          if (name.includes("security")) return "#fff4e6";
          if (name.includes("release")) return "#e6fff4";
          if (name.includes("api") || name.includes("integration"))
            return "#eef2ff";
          if (name.includes("data") || name.includes("report"))
            return "#fff8e6";
        }
        return "#f7fafc"; // neutral
    }
  };

  const userDetails = [
    { label: "Full Name", value: name, icon: PersonOutlineOutlinedIcon },
    { label: "CNIC", value: maskCnic(cnic), icon: AssignmentOutlinedIcon },
    { label: "Role", value: roleName, icon: VerifiedUserOutlinedIcon },
    { label: "Office", value: code === '10' ? "PITC":officeNameForDashboard, icon: BusinessOutlinedIcon },
    { label: "Email", value: email, icon: MailOutlineOutlinedIcon },
    { label: "Phone", value: phoneNo, icon: PhoneOutlinedIcon },
  ];

  const handleOpenProfileEditPopup = () => {
    window.dispatchEvent(new Event("open-profile-edit-popup"));
  };

  return (
    <Box className="dummy-dashboard">
      <Box className="dummy-dashboard__surface">
        <Box className="dummy-dashboard__hero">
          <img
            src={BannerImg}
            alt=""
            className="dummy-dashboard__hero-bg"
          />
          <Box className="dummy-dashboard__hero-copy">
            <Typography className="dummy-dashboard__welcome">
              Welcome back, {name} <span>👋</span>
            </Typography>

            <Stack className="dummy-dashboard__meta" direction="row" spacing={0} useFlexGap flexWrap="wrap">
              {dashboardMeta.map((meta) => (
                <MetaBlock key={meta.label} {...meta} />
              ))}
            </Stack>
          </Box>
        </Box>

        <Box className="dummy-dashboard__content">
          {roleTypeId === "1" && (
            <>
              <Typography className="dummy-dashboard__section-title">
                Quick Actions
              </Typography>

              <Grid
                container
                spacing={2.25}
                className="dummy-dashboard__quick-actions"
              >
                {quickActions.map((action, idx) => {
                  const ActionIcon = action.icon;

                  const handleClick = () => {
                    // View (0) and Create (1) should open Commercial Operations menu
                    if (idx === 0 || idx === 1) {
                      window.dispatchEvent(new Event("openSidebar"));
                      const parentKey =
                        permissionsVariables.commercialOperations ||
                        "Commercial Operations";
                      window.dispatchEvent(
                        new CustomEvent("openSidebarMenu", {
                          detail: { keys: [parentKey] },
                        }),
                      );
                      return;
                    }

                    // Download Reports (3) opens the reports submenu depending on roleTypeId
                    if (idx === 3) {
                      window.dispatchEvent(new Event("openSidebar"));
                      if (String(roleTypeId) === "1") {
                        const parentKey =
                          permissionsVariables.commercialOperations ||
                          "Commercial Operations";
                        window.dispatchEvent(
                          new CustomEvent("openSidebarMenu", {
                            detail: { keys: [parentKey, "CommercialReports"] },
                          }),
                        );
                      } else if (String(roleTypeId) === "2") {
                        window.dispatchEvent(
                          new CustomEvent("openSidebarMenu", {
                            detail: {
                              keys: [
                                "TechnicalOperations",
                                "ComplaintsReports",
                              ],
                            },
                          }),
                        );
                      } else {
                        const parentKey =
                          permissionsVariables.commercialOperations ||
                          "Commercial Operations";
                        window.dispatchEvent(
                          new CustomEvent("openSidebarMenu", {
                            detail: { keys: [parentKey, "CommercialReports"] },
                          }),
                        );
                      }
                      return;
                    }

                    // Search card (2) opens the global search popup
                    if (idx === 2) {
                      window.dispatchEvent(new Event("openSearchPopup"));
                      return;
                    }

                    // System Notices (last card) navigates to eOps updates page
                    if (idx === 4) {
                      navigate("/eops-updates");
                      return;
                    }

                    if (action.onClick) action.onClick();
                  };

                  return (
                    <Grid item xs={12} sm={6} md key={action.title}>
                      <Card
                        className="dummy-dashboard__action-card"
                        onClick={handleClick}
                        sx={{ cursor: "pointer" }}
                      >
                        <CardContent className="dummy-dashboard__action-card-content">
                          <Box className="dummy-dashboard__action-icon">
                            <ActionIcon fontSize="small" />
                          </Box>
                          <Typography className="dummy-dashboard__action-title">
                            {action.title}
                          </Typography>
                          <Typography className="dummy-dashboard__action-description">
                            {action.description}
                          </Typography>
                          <Box className="dummy-dashboard__action-arrow">
                            <ChevronRightRoundedIcon />
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </>
          )}

          <Grid container spacing={2.25} className="dummy-dashboard__panels">
          <Grid item xs={12} lg={4}>
            <Card className="dummy-dashboard__panel-card">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box className="dummy-dashboard__panel-header">
                  <Box className="dummy-dashboard__panel-header-left">
                    <PersonOutlineOutlinedIcon fontSize="small" />
                    <Typography>User Information</Typography>
                  </Box>
                  {/* <Typography
                    className="dummy-dashboard__panel-link"
                    onClick={handleOpenProfileEditPopup}
                    sx={{ cursor: "pointer" }}
                  >
                    <EditOutlinedIcon fontSize="small" />
                    Edit Profile
                  </Typography> */}
                </Box>

                <Divider className="dummy-dashboard__divider" />

                <Box className="dummy-dashboard__user-area">
                  <Avatar
                    src={profilePicture || UserAvatar}
                    alt={name}
                    className="dummy-dashboard__avatar"
                  />
                  <Box>
                    <Typography className="dummy-dashboard__user-name">
                      {name}
                    </Typography>
                  </Box>
                </Box>

                <Box className="dummy-dashboard__details">
                  {userDetails.map((detail) => {
                    const DetailIcon = detail.icon;

                    return (
                      <Box className="dummy-dashboard__detail-row" key={detail.label}>
                        <Box className="dummy-dashboard__detail-label-wrap">
                          <DetailIcon fontSize="small" />
                          <Typography className="dummy-dashboard__detail-label">
                            {detail.label}
                          </Typography>
                        </Box>
                        <Typography className="dummy-dashboard__detail-value">
                          {detail.value}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* <Grid item xs={12} lg={4}>
            <Card className="dummy-dashboard__panel-card">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box className="dummy-dashboard__panel-header">
                  <Box className="dummy-dashboard__panel-header-left">
                    <AccessTimeOutlinedIcon fontSize="small" />
                    <Typography>Recent Activity</Typography>
                  </Box>
                  <Typography className="dummy-dashboard__panel-link">
                    View All
                  </Typography>
                </Box>

                <Divider className="dummy-dashboard__divider" />

                <Box className="dummy-dashboard__activity-list">
                  {recentActivity.map((activity, index) => {
                    const ActivityIcon = activity.icon;

                    return (
                      <Box className="dummy-dashboard__activity-item" key={`${activity.title}-${index}`}>
                        <Box className={`dummy-dashboard__activity-dot dummy-dashboard__activity-dot--${activity.tone}`}>
                          <ActivityIcon className="dummy-dashboard__activity-symbol" fontSize="small" />
                        </Box>
                        <Box>
                          <Typography className="dummy-dashboard__activity-title">
                            {activity.title}
                          </Typography>
                          <Typography className="dummy-dashboard__activity-time">
                            {activity.time}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </CardContent>
            </Card>
          </Grid> */}

          <Grid item xs={12} lg={8}>
            <Card className="dummy-dashboard__panel-card">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box className="dummy-dashboard__panel-header">
                  <Box className="dummy-dashboard__panel-header-left">
                      <NotificationsNoneOutlinedIcon fontSize="small" />
                      <Typography>Announcements / Notices</Typography>
                    </Box>
                    {eopsTotalCount > 4 && (
                      <Typography
                        className="dummy-dashboard__panel-link"
                        sx={{ cursor: "pointer" }}
                        onClick={() => navigate("/eops-updates")}
                      >
                        {`View All (${eopsTotalCount})`}
                      </Typography>
                    )}
                  </Box>

                <Divider className="dummy-dashboard__divider" />

                  <Stack
                    spacing={1.75}
                    className="dummy-dashboard__notice-list"
                  >
                    {/* First show server-provided eOps updates (if any) */}
                    {eopsNotices && eopsNotices.length > 0 ? (
                      eopsNotices.slice(0, 4).map((notice) => {
                        const IconComp = getUpdateIcon(
                          notice.updateTypeId,
                          notice.updateTypeName,
                        );
                        return (
                          <Box
                            key={`eops-${notice.id}`}
                            className={`dummy-dashboard__notice-card dummy-dashboard__notice-card--${notice.tone}`}
                            style={{
                              background: getUpdateBgColor(
                                notice.updateTypeId,
                                notice.updateTypeName,
                              ),
                            }}
                          >
                            <Box className="dummy-dashboard__notice-icon">
                              <IconComp fontSize="small" />
                            </Box>
                            <Box>
                              <Typography className="dummy-dashboard__notice-title">
                                {notice.title}
                              </Typography>
                              <Typography className="dummy-dashboard__notice-description">
                                {notice.description}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })
                    ) : (
                      <Box
                        className="dummy-dashboard__notice-empty"
                        sx={{ padding: 2, color: "#6b7280" }}
                      >
                        No announcements available.
                      </Box>
                    )}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Backdrop open={viewBackdrop} sx={{ zIndex: 1400, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default DummyDashboard;